import { refs } from './refs.js';

/**
 * Front-my-End — Dialog Modal Utilities
 */
export const Modal = {
  /**
   * Displays a generic messages/errors modal dialog.
   * @param {string} title
   * @param {Node|string|Array<Node|string>} content
   */
  showMessage(title, content) {
    const modal = refs.messageModal;
    const titleEl = refs.messageModalTitle;
    const bodyEl = refs.messageModalBody;
    if (!modal || !bodyEl) return;
    if (titleEl) titleEl.textContent = title;
    bodyEl.replaceChildren(...Modal.toNodes(content));
    if (typeof modal.showModal === 'function') {
      modal.showModal();
    }
  },

  /**
   * Converts safe text or constructed DOM nodes into content for replaceChildren.
   */
  toNodes(content) {
    const values = Array.isArray(content) ? content : [content];
    return values
      .filter((value) => value !== null && value !== undefined)
      .map((value) => value instanceof Node ? value : document.createTextNode(String(value)));
  }
};
